export const API_URL = process.env.API_URL;
export const LIVE_PRICE_URL = process.env.LIVE_PRICE_URL;
export const APP_VERSION = process.env.APP_VERSION;
export const TERMS_URL = process.env.TERMS_URL;
export const SENTRY_DSN = process.env.SENTRY_DSN;
export const MERCHANT_ID = process.env.MERCHANT_ID;
